import {InputTypes} from "./components/FormStepper/InputTypes";
import {formStores} from "./state/mobx";
import MixPanelAnalyticsService from "../../services/Analytics/MixPanelAnalyticsService";
import {AnalyticsSignUpEvents} from "../../services/Analytics/AnalyticsSignUpEvents";
import {LoanReason} from "shared/functions/membersApi/types/IPlanRequests";
import Config from "../../services/Config/Config";
import {FormVerificationTexts} from "./screens/SignUpForm/FormVerification/FormVerificationTexts";

const signUpStore = formStores.formStore;
const lendioStore = formStores.shortSignupStore;
const sbaLoanStore = formStores.sbaLoanStore;
const coverageStore = formStores.coverageStore;
const upgradeStore = formStores.upgradeStore;

export default class FormUtils {
    public static validateInput = (inputType: InputTypes, inputValue: any, customValidation?: (inputValue:string) => boolean) => {
        if (FormUtils.falseInput(inputType, inputValue)) {
            return false;
        }
        if (customValidation) {
            return customValidation(inputValue)
        }
        const res = FormUtils.validateInputByType(inputType, inputValue);
        return res;
    };

    public static validateEmailChars = (inputValue: string) => {
        const reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
        if(!signUpStore.isEmailValid) {
            return false;
        }
        return reg.test(inputValue);

    };

    public static validateEmailPattern = (inputValue: string) => {
        const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;;
        return re.test(String(inputValue.trim()).toLowerCase());
    };

    public static setInputDisable = (isPreviousStepFinished: boolean, isFirst: boolean | undefined) => {
        return !isPreviousStepFinished && !isFirst;
    };

    public static setFormNavigationOnInit = (formPageName: any, store: any) => {
        if(!store.formInput[formPageName]) {
            store.formInput[formPageName] = {};
            store.navigationController[formPageName] = false;
        }else {
            const formInput = store.formInput[formPageName];
            const values = Object.keys(formInput).map(key => formInput[key]);
            let formInputFlag = true;
            values.forEach((value: any) => {
                if(!value && formInputFlag) {
                    store.navigationController[formPageName] = false;
                    formInputFlag = false;
                }
            });
            store.navigationController[formPageName] = formInputFlag;
        }
    };

    public static updateAnalytics = (propertyName: string, store: any, formPageName: string) => {
        switch (propertyName) {
            case "fullName":  MixPanelAnalyticsService.track(AnalyticsSignUpEvents.FullNameEntered, {fullName: signUpStore.formInput.business.fullName}); break;
            case "userEmail": MixPanelAnalyticsService.track(AnalyticsSignUpEvents.WorkEmail, {Email: signUpStore.formInput.business.userEmail}); break;
            case "userCompanyName": MixPanelAnalyticsService.track(AnalyticsSignUpEvents.Company, {Email: signUpStore.formInput.business.userCompanyName, user: signUpStore.formInput.business.userEmail}); break;
            case "depositAmount": {
                const deposit = signUpStore.formInput.financial.depositAmount;
                deposit === " "? MixPanelAnalyticsService.track(AnalyticsSignUpEvents.NoAmount) :  MixPanelAnalyticsService.track(AnalyticsSignUpEvents.InsertAmount, {amount: deposit});
                break;
            }
            case "contactEmail": {
                if(signUpStore.formInput.verification) {
                    const cmMail = signUpStore.formInput.verification.contactEmail;
                    cmMail === "" ? MixPanelAnalyticsService.track(AnalyticsSignUpEvents.CmEmailSkipped) : MixPanelAnalyticsService.track(AnalyticsSignUpEvents.CmEmail);
                }
                break;
            }
        }

    };

    public static optionSelected = (options: any[] | undefined) => {
        if(!options) {return;}
        const isSelectedOption = options.find(o => o.isSelected);
        return isSelectedOption
    }

    public static renderReasonsArray = () => {
        const options = [];
        for (const key in LoanReason) {
            if(LoanReason[key]) {
                options.push({label: LoanReason[key], value: key})
            }
        }
        return options;
    }

    public static validatePhoneNumber = (value: string) => {
        if(!value) {
            return false;
        }
        const nonSpacesValue = value.replace(/\s/g, '');
        return nonSpacesValue.length === 13;

    }

    public static fileUploadHandler = ( files: File[], propertyName: string) => {
        const reader = new FileReader();
        reader.readAsDataURL(files[0]);
        const fileName = files[0].name

        reader.onload = () => {
            const binaryStr = reader.result;
            switch (propertyName) {
                case FormVerificationTexts.propertyNames.IMAGE_ID: signUpStore.updateIdImage(binaryStr, propertyName); break;
                case FormVerificationTexts.propertyNames.SIGNUP_PDF: signUpStore.updateMembership(binaryStr); break;
                case "lendioId":  lendioStore.updateLendioId(binaryStr); break;
                case "sbaFirstPdfFile": sbaLoanStore.uploadFirstPdf(binaryStr, fileName); break;
                case "sbaSecondPdfFile": sbaLoanStore.uploadSecondPdf(binaryStr, fileName); break;
                case "sbaThirdPdfFile": sbaLoanStore.uploadThirdPdf(binaryStr, fileName); break;
                case "upgradePdfFile": upgradeStore.updateLease(binaryStr); break;
                case "coveragePdfFile": coverageStore.formInput.coverage.coveragePdfFile = binaryStr; break;
                default: break;
            }
        };
    }

    public static validate9CharactersLength = (val: string) => {
        if(!val) {
            return false;
        }
        return val.length === 0? false : val.length === 9;
    };

    public static loanAmountBounds = (val: string) => {
        if(!val) {
            return false;
        }

        const parsedValue = parseInt(val.toString().replace(/,/g, ""), 10);
        if(isNaN(parsedValue)) {
            return false
        }
        return parsedValue < 250001 && parsedValue > 999;
    };

    public static falseInput = (inputType: InputTypes, inputValue: any) => {
        const ignoreInputs = [InputTypes.none, InputTypes.nested, InputTypes.file];
        return inputValue === "" && ignoreInputs.includes(inputType);
    };

    public static validateInputByType = (inputType: InputTypes, inputValue: any) => {
        const allowAllInputs = [InputTypes.dropdown, InputTypes.multipleSelect, InputTypes.number, InputTypes.locationSearch, InputTypes.amount, InputTypes.multipleCheckSelect, InputTypes.boolean, InputTypes.calendar];
        const filesUnFinishedStatus = ["sending", ""];
        const minimumThreeChars = [InputTypes.locationSearch, InputTypes.text];
        if ((allowAllInputs.includes(inputType) && inputValue !== undefined  && inputValue !== "")
            || (inputType ===InputTypes.file && !filesUnFinishedStatus.includes(inputValue))
            || (minimumThreeChars.includes(inputType) && inputValue && inputValue.length > 2)
            || (inputType === InputTypes.email && (FormUtils.validateEmailChars(inputValue) || inputValue === false))
            || (inputType ===InputTypes.phoneNumber && FormUtils.validatePhoneNumber(inputValue))) {
            return true;
        }
        return false
    };

    public static getLoginLink = () => {
        if(Config.isDev()) {
            return "https://dev.app.salaryo.com/login"
        }
        return "https://app.salaryo.com/login";
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/FormUtils.ts